import React from 'react'
import styled from 'styled-components'
import { mixinInputForm } from 'spa/client/styles/mixin'
import { useFormContext } from 'react-hook-form'

export type Props = {
  name: string,
  defaultValue?: string,
  required?: boolean,
  disabled?: boolean,
}

const StyledTextarea = styled.textarea`
  ${mixinInputForm}
  padding-top: .75rem;
  padding-bottom: .75rem;
  
  width: 100%;
  height: 160px;
  border-color: #cccccc;
`

export const StyledTextAreaForm: React.FC<Props> = (props: Props) => {
  const { register } = useFormContext()

  // TODO react-hook-formを使ったバリデーションエラーメッセージ表示の実装をしたい
  return <StyledTextarea defaultValue={props.defaultValue || ''} required={props.required} disabled={props.disabled} placeholder={'入力してください'} {...register(props.name, { required: { value: props.required } })} />
}
